

export default {
  SET_ITEMS(state, payload) {
    state.statis_artisans = payload
  },

  SET_INTERVENTIONS_STATISTICS(state, payload) {
    state.statis_interventions = payload
  }
}
